export default __webpack_public_path__ + "media/images/78-e5c64774dd180e61533f855ace2822af.jpg";